import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import CharityLayout from "../layout/CharityLayout";
import { ActiveBarProvider } from "../ActiveBarContext";

import CharityDashboard from "../charity/CharityDashboard";
import LinkedBars from "../charity/LinkedBars";
import Gaming from "../charity/Gaming";
import Subscription from "../charity/Subscription";
import Help from "../charity/Help";

import ClaimBar from "../shared/ClaimBar";
import EventsPage from "../shared/EventsPage";
import NotificationsPage from "../shared/NotificationsPage";
import AccountSettings from "../shared/AccountSettings";

export default function CharityDashboardRouter() {
  // Keep each account in its own dashboard: a owner account that lands
  // on a charity page (old tab, back button) gets sent to its own dashboard.
  const { user, role } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (role === "owner") return <Navigate to="/owner" replace />;

  return (
    <ActiveBarProvider roleField="charityId">
      <CharityLayout>
        <Routes>
          <Route path="" element={<CharityDashboard />} />
          <Route path="claim-bar" element={<ClaimBar />} />
          <Route path="events" element={<EventsPage />} />
          <Route path="linked-bars" element={<LinkedBars />} />
          <Route path="gaming" element={<Gaming />} />
          <Route path="notifications" element={<NotificationsPage />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="help" element={<Help />} />
          <Route path="account" element={<AccountSettings />} />
        </Routes>
      </CharityLayout>
    </ActiveBarProvider>
  );
}
